import { colors } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

import Barcode from 'common/illustrations/Barcode';
import { Typography as T } from 'common/typography';

type Props = {
  percentage: number;
  children?: ReactNode;
};

const ProgressContainer = styled.div`
  margin: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ProgressText = styled(T.Body1)`
  text-align: center;
`;

const ProgressBar = styled.div<{ percentage: number }>`
  position: relative;
  margin-block-start: 36px;
  display: block;
  height: 16px;
  border-radius: 10px;
  background-color: ${cssThemedValue({ light: colors.pepper12, dark: colors.salt16 })};
  ::after {
    position: absolute;
    content: '';
    display: block;
    height: 100%;
    width: ${({ percentage }) => percentage}%;
    border-radius: 10px;
    background-color: ${colors.lime100};
    transition: width 500ms ease-out;
  }
`;

const ProgressTracking = ({ percentage, children }: Props) => (
  <ProgressContainer>
    <Barcode />
    <ProgressText>{children}</ProgressText>
    <ProgressBar percentage={Math.max(percentage, 3)} />
  </ProgressContainer>
);

export default ProgressTracking;
